import cn from '@/lib/cs';
import React from 'react';

const HeartIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="m11.8 22-.2-.5L9.2 20l-3.5-3.5L2.5 13 1 8.2l1.7-4.6L7.1 2l4.7 2.9 4.7-2.7L20.7 4 23 8.2l-1.6 4.9-3 3.8-3.9 3.2-2 1.7-.7.2Z"
		/>
	</svg>
);

export default HeartIcon;
